import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";
import { Shield } from "lucide-react";

export default function AdminLogin() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const user = await login(email, password);
      if (user.role !== "admin") {
        toast.error("Not an admin account");
        return;
      }
      toast.success("Welcome, admin");
      navigate("/admin");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-24" data-testid="admin-login-page">
      <div className="flex items-center gap-2 label-eyebrow mb-3"><Shield size={14} /> Admin Console</div>
      <h1 className="font-serif-display text-4xl text-white">Restricted <span className="italic text-[#D4AF37]">access</span></h1>
      <form onSubmit={submit} className="mt-10 space-y-4">
        <input data-testid="admin-email" required type="email" placeholder="Admin email" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full bg-black border border-white/15 focus:border-[#D4AF37] outline-none px-4 py-3 rounded text-white" />
        <input data-testid="admin-password" required type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} className="w-full bg-black border border-white/15 focus:border-[#D4AF37] outline-none px-4 py-3 rounded text-white" />
        <button data-testid="admin-login-submit" disabled={loading} className="btn-gold w-full py-3 rounded text-sm tracking-widest uppercase font-semibold">
          {loading ? "Signing in..." : "Sign In"}
        </button>
      </form>
    </div>
  );
}
